import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../HomeView.vue'
import PaymentSuccess from '../PaymentSuccess.vue'
import PaymentFailure from '../PaymentFailure.vue'

// function getLocalePath(path, locale) {
//   return path + (locale ? '-' + locale : ''); // 根据是否提供locale来决定是否添加后缀
// }

// params: { lang: 'zh' },
const routes = [
  { path: '/', redirect: '/survey' },
  // { path: '/', redirect: '/survey/:lang', component: HomeView, params: { lang: 'zh' } },
  { path: '/survey', component: HomeView },
  { path: '/succeed', component: PaymentSuccess },
  { path: '/failure', component: PaymentFailure },
  // { path: '/survey/:lang', name: 'HomeView', component: HomeView },
  // { path: '/survey', component: HomeView, params: { lang: 'en' }, meta: { lang: 'en' } },
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})
export default router